import React from "react";
import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import theme from "../../../theme/Theme";

const Testimonials = () => {
  return (
    <Box sx={{ ...styles.section, bgcolor: theme.custom.primaryLighter }}>
      <Container maxWidth="lg">
        <Typography sx={styles.sectionTitle}>
          Built for Influencers.{" "}
          <span style={styles.titleHighLight}>Trusted by Creators.</span>
        </Typography>
        <Grid container spacing={3} sx={styles.testimonialsContainer}>
          {testimonials.map((testimonial, index) => (
            <Grid item xs={12} md={6} key={index}>
              <Card sx={styles.testimonialCard}>
                <CardContent>
                  <Typography sx={styles.testimonialText}>
                    {testimonial.text}
                  </Typography>
                  <Typography sx={styles.testimonialAuthor}>
                    — {testimonial.author}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

const testimonials = [
  {
    text: "Got paid in under 5 seconds after my first referral!",
    author: "@cryptoGrowth",
  },
  {
    text: "Finally, a system that pays in something real — USDT.",
    author: "@web3marketer",
  },
];

const styles = {
  section: {
    padding: { xs: "60px 0", md: "100px 0" },
    position: "relative",
  },
  sectionTitle: {
    fontWeight: "800",
    margin: "0.2em 2em 0.3em 1em",
    fontSize: { xs: "5.5vw", lg: "3.2vw" },
    textAlign: "center",
    color: theme.custom.black,
    textTransform: "uppercase",
    zIndex: 99,
  },
  titleHighLight: {
    color: theme.palette.primary.main,
    borderBottom: "1.5px solid rgba(0, 0, 0, 1)",
  },
  testimonialsContainer: {
    maxWidth: "1000px",
    margin: "0 auto",
  },
  testimonialCard: {
    backgroundColor: theme.custom.white,
    borderRadius: "10px",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)",
  },
  testimonialText: {
    fontSize: "1.2rem",
    fontStyle: "italic",
    marginBottom: "20px",
    fontFamily: '"Proxima Nova", sans-serif',
  },
  testimonialAuthor: {
    fontWeight: 700,
    color: theme.palette.primary.main,
    fontFamily: '"Proxima Nova", sans-serif',
  },
};

export default Testimonials;
